/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListMCPPlatformToolsetsRequest,
  ListMCPPlatformToolsetsSecurity,
} from "../models/operations/listmcpplatformtoolsets.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildRiskListMcpPlatformToolsetsQuery,
  prefetchRiskListMcpPlatformToolsets,
  queryKeyRiskListMcpPlatformToolsets,
  RiskListMcpPlatformToolsetsQueryData,
} from "./riskListMcpPlatformToolsets.core.js";
export {
  buildRiskListMcpPlatformToolsetsQuery,
  prefetchRiskListMcpPlatformToolsets,
  queryKeyRiskListMcpPlatformToolsets,
  type RiskListMcpPlatformToolsetsQueryData,
};

export type RiskListMcpPlatformToolsetsQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listMCPPlatformToolsets risk
 *
 * @remarks
 * List code-owned Platform MCP toolsets available as risk policy scope targets.
 */
export function useRiskListMcpPlatformToolsets(
  request?: ListMCPPlatformToolsetsRequest | undefined,
  security?: ListMCPPlatformToolsetsSecurity | undefined,
  options?: QueryHookOptions<
    RiskListMcpPlatformToolsetsQueryData,
    RiskListMcpPlatformToolsetsQueryError
  >,
): UseQueryResult<
  RiskListMcpPlatformToolsetsQueryData,
  RiskListMcpPlatformToolsetsQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildRiskListMcpPlatformToolsetsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listMCPPlatformToolsets risk
 *
 * @remarks
 * List code-owned Platform MCP toolsets available as risk policy scope targets.
 */
export function useRiskListMcpPlatformToolsetsSuspense(
  request?: ListMCPPlatformToolsetsRequest | undefined,
  security?: ListMCPPlatformToolsetsSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    RiskListMcpPlatformToolsetsQueryData,
    RiskListMcpPlatformToolsetsQueryError
  >,
): UseSuspenseQueryResult<
  RiskListMcpPlatformToolsetsQueryData,
  RiskListMcpPlatformToolsetsQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildRiskListMcpPlatformToolsetsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setRiskListMcpPlatformToolsetsData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: RiskListMcpPlatformToolsetsQueryData,
): RiskListMcpPlatformToolsetsQueryData | undefined {
  const key = queryKeyRiskListMcpPlatformToolsets(...queryKeyBase);

  return client.setQueryData<RiskListMcpPlatformToolsetsQueryData>(key, data);
}

export function invalidateRiskListMcpPlatformToolsets(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "policies",
      "listMcpPlatformToolsets",
      ...queryKeyBase,
    ],
  });
}

export function invalidateAllRiskListMcpPlatformToolsets(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "policies", "listMcpPlatformToolsets"],
  });
}
